import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface AssignedWorkerLabelProps {
    isContractors?: boolean;
    total: number;
    remaining: number;
}

export const AssignedWorkerLabel: React.FC<AssignedWorkerLabelProps> = ({ isContractors, total, remaining }) => {
    const { t } = useTranslation();

    if (remaining < 0) {
        return (
            <Trans
                t={t}
                i18nKey={`wageRanger.${isContractors ? 'contractor' : 'employee'}.tooMany`}
                ns="components"
                values={{
                    total: total,
                    excess: Math.abs(remaining)
                }}
                components={{
                    strong: <strong />
                }}
            />
        );
    }
    return (
        <>
            {!remaining ? (
                <Trans
                    t={t}
                    i18nKey={`wageRanger.${isContractors ? 'contractor' : 'employee'}.allAssigned`}
                    ns="components"
                    values={{
                        total: total
                    }}
                    components={{
                        strong: <strong />
                    }}
                />
            ) : (
                <Trans
                    t={t}
                    i18nKey={`wageRanger.${isContractors ? 'contractor' : 'employee'}.assignedProgress`}
                    ns="components"
                    values={{
                        unassigned: remaining,
                        total: total
                    }}
                    components={{
                        strong: <strong />
                    }}
                />
            )}
        </>
    );
};
